// extracted by mini-css-extract-plugin
export var addButton = "_oc-0";
export var border = "_oc-8";
export var check = "_oc-h";
export var danger = "_oc-6";
export var dropdownContainer = "_oc-1";
export var editModalBody = "_oc-j";
export var footerContainer = "_oc-i";
export var fullWidth = "_oc-a";
export var hide = "_oc-9";
export var icon = "_oc-3";
export var input = "_oc-7";
export var inputFlex = "_oc-b";
export var inputWrapper = "_oc-c";
export var manualFocus = "_oc-5";
export var optionButton = "_oc-4";
export var pillWrapper = "_oc-e";
export var pointer = "_oc-2";
export var showOverflow = "_oc-f";
export var tagsFlex = "_oc-d";
export var xButton = "_oc-g";